import { axiosInstanceWithCredentials } from "./base";


export function getHardwares(params) {
  return axiosInstanceWithCredentials.get("/hardwares", {
    params
  });
}

export function getHardware(id,params) {
  return axiosInstanceWithCredentials.get(`/hardware/${id}`, {
    params
  });
}

export function addHardware(data) {
  return axiosInstanceWithCredentials.post(`/hardware/`, data, )
}

export function updateHardware(id,data) {
  return axiosInstanceWithCredentials.put(`/hardware/${id}`, data);
}

export function deleteHardware(id) {
  return axiosInstanceWithCredentials.delete(`/hardware/${id}`);
}

export function addFirmware(data) {
  return axiosInstanceWithCredentials.post(`/firmware/`, data)
}
export function updateHardwareModule(name,data) {
  return axiosInstanceWithCredentials.put(`/firmware/module/${name}`,data);
}

export function updateFirmware(id,data) {
  let headers = {'Content-Type': 'multipart/form-data'};
  const form = new FormData();

  Object.keys(data).forEach(function (key) {
    if(key==="WinkyBinary"){
      if(data[key].name) {
        form.append(key, data[key], data[key].name)
      }
    }else {
      form.append(key, data[key])
    }
  })
  return axiosInstanceWithCredentials.put(`/firmware/${id}`, form, {headers: headers});
}

export function getFirmware(id,params) {
  return axiosInstanceWithCredentials.get(`/firmware/${id}`, {
    params
  });
}

export function deleteFirmware(id) {
  return axiosInstanceWithCredentials.delete(`/firmware/${id}`);
}
